import { render, staticRenderFns } from "./index.md?vue&type=template&id=2005f001&"
import script from "./index.md?vue&type=script&lang=js&"
export * from "./index.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2005f001')) {
      api.createRecord('2005f001', component.options)
    } else {
      api.reload('2005f001', component.options)
    }
    module.hot.accept("./index.md?vue&type=template&id=2005f001&", function () {
      api.rerender('2005f001', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/test/index.md"
export default component.exports